const isAzure = () => {
  return /azportal\./.test(window.location.host)
}

export default isAzure
